import React from "react";
import { CV } from "../components/cv";
import PatrikRImg from "@/assets/images/patrik-r.png";

export default function CVPatrikRizell() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Patrik Rizell";
  }, []);

  return (
    <CV
      name="Patrik Rizell"
      title="Developer"
      subtitle="Fullstack C# and React with 15+ years in the industry — engagements at Fitness24Seven and Tunstall"
      photo={PatrikRImg}
      summary="Fullstack developer with 15+ years of experience and a main focus on backend. A generalist who values clean code, SOLID principles, and good architecture while staying goal-oriented and delivering value on deadline. Strong communicator who enjoys discussions on architecture and improving organizational processes."
      skills={{
        "Languages": ["C#", ".NET", "JavaScript", "TypeScript", "XML"],
        "Frontend": ["React", "React Native", "Next.js", "Single-spa", "WPF"],
        "Backend": ["Microservices", "Minimal APIs", "GraphQL", "REST APIs", "Kafka", "SQL", "MySQL"],
        "Cloud & DevOps": ["Azure", "Docker"],
        "Methods": ["Software Architecture", "Clean Code", "SOLID", "Scrum"],
      }}
      experience={[
        {
          role: "Senior Software Developer",
          company: "Fitness24Seven",
          period: "Aug 2023 – Present",
          description:
            "Part of a cross-functional team responsible for app development, web applications, backend services, and Azure environment. Focused on delivering new features, improving legacy systems, and modernizing cloud architecture.",
          highlights: [
            "Key role in a full rewrite of the group workout booking system, achieving a 10x performance improvement during peak load",
            "Led the integration of BankID (SE/NO/FI) for electronic identity verification in the app",
            "Tech: C#, Next.js, React Native, Azure",
          ],
        },
        {
          role: "Founder",
          company: "Bitzell AB",
          period: "Jun 2023 – Present",
          description:
            "Providing consulting services through own firm, with primary focus on fullstack development.",
        },
        {
          role: "Senior Software Developer",
          company: "Tunstall Sverige",
          period: "Sep 2022 – Aug 2023",
          description:
            "Part of a team creating and architecting a global platform for future products, built as an event-based microservice architecture.",
          highlights: [
            "Built alarm response center using Twilio Flex and user management services",
            "Tech: C#, Minimal APIs, Microservices, Kafka, React, Micro frontend with Single-spa",
          ],
        },
        {
          role: "Software Developer",
          company: "EDP",
          period: "Sep 2021 – Sep 2022",
          description:
            "Fullstack developer in a team modernizing a desktop application into a scalable solution using React for frontend and C# microservice backend.",
        },
        {
          role: "Software Developer",
          company: "EDP",
          period: "Jan 2021 – Sep 2021",
          description:
            "Developer and stand-in Project Manager. Created an integration with the Public Health Agency of Sweden that streamlined management and price calculation for serving licenses.",
          highlights: [
            "Conducted user interviews and facilitated continuous demos",
          ],
        },
        {
          role: "Software Developer",
          company: "EDP",
          period: "Jan 2020 – Dec 2020",
          description:
            "Completed a data extraction project in accordance with Swedish National Archives' regulations and integrated extracted data with multiple E-archive systems.",
        },
        {
          role: "Software Developer & Scrum Master",
          company: "EDP",
          period: "Sep 2009 – Sep 2020",
          description:
            "Long-term role developing a framework and product suite for case, supervisory and document management for public administration, government agencies and companies.",
          highlights: [
            "Served as Scrum Master leading a team of 8–9 professionals (2013–2014)",
            "Built common frameworks for easier development and more uniform applications",
          ],
        },
        {
          role: "Thesis Worker",
          company: "Sony Ericsson Mobile Communications",
          period: "Feb 2008 – Jul 2008",
          description:
            "Thesis work at Sony Ericsson.",
        },
      ]}
      education={[
        {
          degree: "Software Development",
          institution: "Lernia",
          year: "2006 – 2008",
        },
      ]}
    />
  );
}
